import { createStyles, makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      display: 'flex',
      minHeight: '100vh',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    form: {
      marginBottom: `${theme.spacing(2)}px`,
      padding: `0 ${theme.spacing(2)}px`,
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      margin: '0 auto',
      maxWidth: 680,
      position: 'relative',
    },
    logo: {
      margin: 'auto',
    },
    languageSelector: {
      position: 'absolute',
      right: 0,
      width: 'fit-content',
    },
    cover: {
      width: '100%',
      maxHeight: '200px',
      objectFit: 'cover',
      [theme.breakpoints.up('md')]: {
        maxHeight: '240px',
      },
    },
    logoWrapper: {
      height: '80px',
      width: '80px',
      borderRadius: '50%',
      boxShadow: 'rgba(0, 0, 0, 0.25) 0px 2.30916px 4.61832px',
      background: theme.palette.common.white,
      position: 'relative',
      top: '-55px',
      marginBottom: '-32px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    rectLogoWrapper: {
      borderRadius: '20px',
    },
    logoBar: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: theme.palette.common.gray100,
      color: theme.palette.text.primary,
      borderBottom: '3px solid',
      borderBottomColor: theme.palette.primary.main,
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    logoBarWithCover: {
      display: 'flex',
      justifyContent: 'space-between',
      height: '36px',
      padding: '4px 16px',
    },
    logoWithCover: {
      height: '100%',
      width: '100%',
    },
    squareLogo: {
      borderRadius: '50%',
    },
    rectLogo: {
      objectFit: 'contain',
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
    },
  }),
);
